import { __rest, __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';

var styles = {"component":"table__component_1yumk","withoutBorder":"table__withoutBorder_1yumk","clickable":"table__clickable_1yumk","selected":"table__selected_1yumk"};
require('./index.css');

var TRow = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, selected = _a.selected, withoutBorder = _a.withoutBorder, dataTestId = _a.dataTestId, restProps = __rest(_a, ["children", "className", "selected", "withoutBorder", "dataTestId"]);
    return (React.createElement("tr", __assign({ className: cn(styles.component, className, (_b = {},
            _b[styles.clickable] = typeof restProps.onClick !== 'undefined',
            _b[styles.selected] = selected,
            _b[styles.withoutBorder] = withoutBorder,
            _b)), "data-test-id": dataTestId }, restProps), React.Children.map(children, function (child, index) { return React.cloneElement(child, { index: index }); })));
};

export { TRow };
